<template>
  <div class="proprietorLogoManageEdit">
    <el-card>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws2" :label-suffix="require('@/config/enum').c_colon">
      <el-form-item :label="$t('lang.lab_logo')" prop="imageUri" ref="imageUri">  
        <upload-file ref="uploading" :accept='accept'  upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
      </el-form-item>
      </el-form>
      <el-button class="btn-first" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_modify')}}</el-button>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:proprietorLogoManageEdit
 *@Description:业主端Logo管理
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-18
 */
import UploadFile from '../../../components/upload_file.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      accept: '.jpg, .jpeg, .png',
      fileList: [], // 图片上传
      clears: false, // 清空按钮
      isDisabled: true, // 修改的可点击
      ruleForm: {
        id: '', // id
        imageUri: '', // 图片
        type: 701, // 类型
      }, // 列表数据
       rules: {
        imageUri: [{ required: true, message: this.$i18n.t('lang.lab_pleaseUploadLogo'), trigger: 'change' }],
      }
    }
  },
  components: {
		'upload-file': UploadFile
	},
  created() {
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.getData()
    },
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取组件值
    getFile(e) {
      this.ruleForm.imageUri = e
      this.$refs.imageUri.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.ruleForm.imageUri = ''
    },
    // 编辑时判断
    checkEdit() {
      this.fileList = []
    },
    // 获取表格数据
    getData() {
      let loading = this.$loading()
      this.$get(`/adsByType/?type=${this.ruleForm.type}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.ruleForm.id = res.id
            this.ruleForm.imageUri = res.imageUri
            this.ruleForm.type = res.type
            if (this.ruleForm.imageUri && this.ruleForm.imageUri != '') {
              this.fileList.push({
                name: '',
                url: this.ruleForm.imageUri.toString()
              }) 
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            id: this.ruleForm.id,
            imageUri: this.ruleForm.imageUri,
            type: this.ruleForm.type,
          }
          let loading = this.$loading()
          this.$patch(`/logo/`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
  }
}
</script>

<style lang= 'scss'>
</style>